import * as React from "react";
import styled from "styled-components";
import { Button, ButtonProps } from "@origin-digital/ods-core";

const ButtonWrapper = styled.div`
  & a {
    border-radius: 0;
  }
  & a span {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const ButtonAction = ({ children, ...others }: ButtonProps) => {
  return (
    <ButtonWrapper>
      <Button component="a" {...others}>
        {children}
      </Button>
    </ButtonWrapper>
  );
};
